import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProjectsByUserId,
  createProject,
  updateProjectById,
  fetchProjectsByTeacher,
  fetchProjects,
  fetchTeacherProjects,
} from "./projectThunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  showPopup: false,
  selectedProjectId: null,
  formData: {
    name: "",
    description: "",
    start_date: "",
    end_date: "",
  },
  currentTab: 0,
  subjectProjects: [],
  allProjects: [],
  teacherProjects: [],
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    handleShowPopup: (state, action) => {
      state.showPopup = action.payload;
    },
    handleFormChange: (state, action) => {
      state.formData[action.payload.name] = action.payload.value;
    },
    setEditProject: (state, action) => {
      state.formData = {
        name: action.payload.name,
        description: action.payload.description,
        start_date: action.payload.start_date,
        end_date: action.payload.end_date,
      };
      state.selectedProjectId = action.payload.id;
      state.showPopup = true;
    },
    setTab: (state, action) => {
      state.currentTab = action.payload;
    },
    resetData: (state, action) => {
      state.teacherProjects = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectsByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProjectsByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createProject.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.loading = false;
        // state.data.push({
        //   ...state.formData,
        //   id: action.payload.id,
        // });
        // state.formData = initialState.formData;
        state.selectedProjectId = null;
      })
      .addCase(createProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProjectById.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjectById.fulfilled, (state, action) => {
        state.loading = false;
        // const index = state.data.findIndex(
        //   (item) => item.id === action.payload.id
        // );
        // if (index !== -1) {
        //   state.data[index] = { ...state.data[index], ...action.payload };
        // }
        // state.formData = initialState.formData;
        state.selectedProjectId = null;
      })
      .addCase(updateProjectById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProjectsByTeacher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectsByTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.subjectProjects = action.payload;
      })
      .addCase(fetchProjectsByTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.allProjects = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeacherProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherProjects = action.payload || [];
      })
      .addCase(fetchTeacherProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  handleShowPopup,
  handleFormChange,
  setEditProject,
  setTab,
  resetData,
} = projectSlice.actions;
export default projectSlice.reducer;
